import { Component, Inject, OnInit, PLATFORM_ID } from '@angular/core';
import { LocaleService } from 'src/app/shared/services/translate.service';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  keyframes,
} from '@angular/animations';
import { environment } from 'src/environments/environment';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'guest-section2',
    templateUrl: './section2.component.html',
    styleUrls: ['./section2.component.scss'],
    animations: [
        
        trigger('openClose', [
            state('true', style({ color: "#b86814" })),
            state('false', style({ color: "#b86814" })),
            transition('false => true', [
                style({ opacity: 0 }),
                animate(3000, style({ opacity: 1 }))
            ])
        ]),
        trigger('rotateState', [
          state('spinin', style({ transform: 'rotate(0deg)' })),
          state('spinout', style({ transform: 'rotate(360deg)' })),
          transition('spinin <=> spinout', animate('0.5s ease-in-out'))
        ])
    ],
    standalone: false
})
export class Section2Component implements OnInit {
  appiworksLogo: string = "https://storage.googleapis.com/jivrus-web-images/products/appiworks/appiworks-logo.png";
  baseURL: any = environment.LOGO_BASE_URL;

  conrotate: string = "spinout";
  bloomrotate: string = "spinout";
  flowrotate: string = "spinout";
  formrotate: string = "spinout";

  changing_qoute: string = "Model every system"
  changing_qoutes: string[] = [
    `Model every system`,
    `Interact with any`,
    `One platform for all your applications`,
    `Connect with Applications, through various authentication mechanism`,
    `Visually Build Integrated Applications`,
    `Interact directly from major platforms`,
  ];
  isOpen: string= 'true'
  isBrowser: boolean;
  mcprotate: string = "spinout";

  rotationStates = {
    flow: 'spinin',
    bloom: 'spinin',
    connection: 'spinin',
    form: 'spinin',
    mcp: 'spinin'
  };
  

  products = [
    {
      name: 'Flow',
      logoPath: 'flow/appiworks-flow-logo.png',
      pagePath: 'https://appiworks.jivrus.com/products/flow',
      rotateTrigger: 'flowrotate',
      id: 'flow'
    },
    {
      name: 'Bloom',
      logoPath: 'bloom/appiworks-bloom-logo.png',
      pagePath: 'https://appiworks.jivrus.com/products/bloom',
      rotateTrigger: 'bloomrotate',
      id: 'bloom'
    },
    {
      name: 'Connection',
      logoPath: 'connection/appiworks-connection-logo.png',
      pagePath: 'https://appiworks.jivrus.com/products/connection',
      rotateTrigger: 'conrotate',
      id: 'connection'
    },
    {
      name: 'Form',
      logoPath: 'form-builder/aw-form-builder-logo.png',
      pagePath: 'https://appiworks.jivrus.com/products/form',
      rotateTrigger: 'formrotate',
      id: 'form'
    },
    {
      name: 'MCP Server',
      logoPath: 'mcp-server/appiworks-mcp-server-logo.png',
      pagePath: 'https://appiworks.jivrus.com/products/mcp-server',
      rotateTrigger: 'mcprotate',
      id: 'mcp'
    }
  ];
  

  constructor(
    public translate: TranslateService,
    private localeService: LocaleService,
    @Inject(PLATFORM_ID) platformId?: Object
    ) {
      this.isBrowser = isPlatformBrowser(platformId);
      if(!this.isBrowser) return;
    this.translate.use(this.localeService.currentLocale);
   }

  ngOnInit(): void {
    if(!this.isBrowser) return;
    this.changingQouteCallback(this);
  }

  iconMouseEnter(product: any) {
    this[product.rotateTrigger]= 'spinin';
    // Update the rotation state for the rotateState animation
    if (this.rotationStates[product.id]) {
      this.rotationStates[product.id] = 'spinout';
    }
  }
  
  iconMouseLeave(product: any) {
    this[product.rotateTrigger] = 'spinout';
    // Update the rotation state for the rotateState animation
    if (this.rotationStates[product.id]) {
      this.rotationStates[product.id] = 'spinin';
    }
  }
  

  //returns the product translation string
  getProductTranslationString(id: string, type: string): string {
    return `product.${id}.${type}`;
  }

  changingQouteCallback(that: this) {
    let randomNumber = Math.floor(Math.random() * that.changing_qoutes.length);
    that.changing_qoute = that.changing_qoutes[randomNumber];
    that.isOpen = "true";
    setTimeout(that.isOpenChange, 2000, that);
    setTimeout(that.changingQouteCallback, 4000, that);
  }

  isOpenChange(that: this){
    that.isOpen = "false";
  }

}
